import type { AccessError } from '@origo/auth';
import type { AccessDeniedScreenProps } from '../components/AccessDeniedScreen';

/**
 * Oversetter det ferdig-løste `accessError` fra `useAuthenticatedApp` til
 * ferdige AccessDeniedScreen-props, eller null når tilgang er gitt.
 */
export function useAccessErrorScreen(
    accessError: AccessError | null,
    signOut: () => void
): AccessDeniedScreenProps | null {
    if (!accessError) {
        return null;
    }

    if (accessError.kind === 'group') {
        return {
            title: 'Ingen tilgang',
            message: 'Manglende tilgang kan skyldes at brukeren din ikke er medlem av nødvendig gruppe i ArcGIS Online. Ta kontakt med administrator.',
            actionLabel: 'Logg ut',
            onAction: signOut,
        };
    }

    switch (accessError.error.type) {
        case 'NOT_FOUND':
            return {
                title: 'Ingen tilgang',
                message: 'Kunne ikke finne innstillinger for planforvaltning. Ta kontakt med administrator.',
                actionLabel: 'Logg ut',
                onAction: signOut,
            };
        case 'PARSE':
            return {
                title: 'Ingen tilgang',
                message: 'Innstillingene har ugyldig format. Ta kontakt med administrator.',
                actionLabel: 'Logg ut',
                onAction: signOut,
            };
        case 'NETWORK':
        case 'UNKNOWN':
        default:
            return {
                title: 'Ingen tilgang',
                message: 'Kunne ikke laste innstillinger. Prøv igjen senere.',
                actionLabel: 'Prøv igjen',
                onAction: () => window.location.reload(),
            };
    }
}
